import store from "../store"

const permisos = {
    can(permiso) {
        return store.state.user.permisos.includes(permiso);
    }
};

export default permisos;